/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import 'firebase/auth';
import devImage from './developed-by-certi.png';

class SignIn extends Component {
  render() {
    return (
      <a href="https://www.certi.org.br">
        <img src={devImage} alt="developed-by-certi" width="50%" />
      </a>
    );
  }
}

export default withRouter(SignIn);
